export const account_home_mfa = {
  title: "Two-Factor Authentication",
  blurb:
    "Add an authenticator app for admin sign-in. You can set it up or remove it later from this page.",
  cta: "Manage MFA",
} as const;
